var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":this.time ? 'text' : 'date'},domProps:{"value":this.value},on:{"change":_vm.newDate}})}
var staticRenderFns = []

export { render, staticRenderFns }